exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overridable-parameters-editor .loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 5px;\n}\n", ""]);

// exports
